module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-point-image-1-f6d41abb258e751e4682a0c02ca31137.png";